import {  getBaseUrl } from "../../config/api";
import React, { useState, useEffect } from "react";
import "./NuevaVenta.css";
import { User } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import ModalRepresentantesConsult from "./ModalRepresentantesConsult";
import Preloader from "../../components/Preloader";
import { SaleService } from "../../services/SaleService";
import { CategoriaService } from "../../services/CategoriaService";
import { RequisitoService } from "../../services/RequisitoService";
import { DocumentServices } from "../../services/DocumentService";
import { ProductService } from "../../services/ProductService";
import UbicacionVentaConsult from "./UbicacionVentaConsult";

const ConsultarVenta = ({
  token,
  user,
  initialData = {},
  readOnly = false,
  onSave,
}) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [currentStep, setCurrentStep] = useState(1);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [form, setForm] = useState({
    // Paso 1: Información del Cliente
    codigoCliente: initialData.codigoCliente || "",
    tipoDocumento: initialData.tipoDocumento || "",
    numeroDocumento: initialData.numeroDocumento || "",
    nombres: initialData.nombres || "",
    apellidoPaterno: initialData.apellidoPaterno || "",
    apellidoMaterno: initialData.apellidoMaterno || "",
    telefonoContacto: initialData.telefonoContacto || "",
    telefonoContacto2: initialData.telefonoContacto2 || "",
    nombresCompletos: initialData.nombresCompletos || "",
    vendedor_id: initialData.vendedor_id || "",
    fecha_venta: initialData.fecha_venta || "",
    nombre_vendedor: initialData.nombre_vendedor || "",
    apellido_vendedor: initialData.apellido_vendedor || "",

    // Paso 2: Datos de ubicación
    departamento: initialData.departamento || "",
    provincia: initialData.provincia || "",
    distrito: initialData.distrito || "",
    zone: initialData.zone || "",
    direccion: initialData.direccion || "",
    direccionReferencia: initialData.direccionReferencia || "",
    correoElectronico: initialData.correoElectronico || "",

    // Paso 3: Información del producto
    ventaDetalleId: initialData.ventaDetalleId || "",
    categoriaProducto: initialData.categoriaProducto || "",
    producto: initialData.producto || "",
    precio: initialData.precio || "",
    telefonoMigrar: initialData.telefonoMigrar || "",
    fechaInstalacion: initialData.fechaInstalacion || "",
    amPm: initialData.amPm || "",

    // Paso 4: Documentos (DNI, etc.)
    dniFrontal: null,
    dniFrontalPreview: null,
    dniPosterior: null,
    dniPosteriorPreview: null,
    rostroClienteDni: null,
    rostroClienteDniPreview: null,
    frontisCasa: null,
    frontisCasaPreview: null,

    // Paso 5: Documentos adicionales
    reciboLuz: null,
    reciboLuzPreview: null,
    otrosDocumentos: null,
    otrosDocumentosPreview: null,
  });

  const [productos, setProductos] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [requisitos, setRequisitos] = useState([]);
  const [productosFiltrados, setProductosFiltrados] = useState([]);
  const [error, setError] = useState("");
  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingProductos, setLoadingProductos] = useState(false);
  const [loadingCategorias, setLoadingCategorias] = useState(false);
  const [fechaFormateada, setFechaFormateada] = useState("");
  const [horaFormateada, setHoraFormateada] = useState("");
  const [tiposDocumentos, setTiposDocumentos] = useState([]);
  const [representantes, setRepresentantes] = useState([]);
  const [mostrarModalRepresentantes, setMostrarModalRepresentantes] =
    useState(false);

  // Estado para las ubicaciones
  const [locationData, setLocationData] = useState({
    department: initialData.department_id || "",
    province: initialData.province_id || "",
    district: initialData.district_id || "",
    zone: initialData.zone_id || "",
  });

  // Opciones para AM/PM
  const opcionesAmPm = [
    { value: "AM", label: "AM" },
    { value: "PM", label: "PM" },
  ];

  // Función para validar que solo se ingresen números
  const validateNumericInput = (value) => {
    return value.replace(/[^0-9]/g, "");
  };

  function mostrarFechaLegible(fecha) {
    if (!fecha) return "—";

    const date = new Date(fecha);
    if (isNaN(date)) return "—";

    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();
    const hh = String(date.getHours()).padStart(2, '0');
    const min = String(date.getMinutes()).padStart(2, '0');

    return `${dd}/${mm}/${yyyy} ${hh}:${min}`;
  }


  // Función para manejar cambios en campos numéricos
  const handleNumericChange = (e) => {
    const { name, value } = e.target;
    const numericValue = validateNumericInput(value);
    setForm((prev) => ({
      ...prev,
      [name]: numericValue,
    }));
    if (name === "numeroDocumento") {
      setRepresentantes([]);
    }
  };

  const abrirModalRepresentantes = () => setMostrarModalRepresentantes(true);
  const cerrarModalRepresentantes = () => setMostrarModalRepresentantes(false);

  const actualizarRepresentantes = (nuevosRepresentantes) => {
    setRepresentantes(nuevosRepresentantes);
    cerrarModalRepresentantes();
  };

  const handleBackToList = () => {
    navigate("/admin/ventas"); // ajusta según tu ruta de listado
  };


  useEffect(() => {
    const fetchVenta = async () => {
      setLoading(true);
      try {
        const response = await SaleService.fetchVentaPorId(token, id);

        const ventaData = response.data.venta;
        const clienteData = response.data.cliente;
        const ventaDetallesData = response.data.ventaDetalles;
        const fotosRequisitos = response.data.fotosVenta;
        fetchProductos(ventaDetallesData.categoria_id);

        setForm({
          codigoCliente: ventaData.codigo_venta_cliente || "",
          tipoDocumento: String(clienteData.id_tipo_documentos || ""),
          numeroDocumento: clienteData.numero_documento || "",
          nombres: clienteData.nombres || "",
          apellidoPaterno: clienteData.ap_paterno || "",
          apellidoMaterno: clienteData.ap_materno || "",
          telefonoContacto: clienteData.telefono_1 || "",
          telefonoContacto2: clienteData.telefono_2 || "",
          nombresCompletos: clienteData.cliente_razon_social || "",
          vendedor_id: ventaData.id_usuario || "",
          nombre_vendedor: ventaData.nombre_vendedor,
          perfil_vendedor: ventaData.perfil_vendedor,
          apellido_vendedor: ventaData.apellido_vendedor,
          departamento: clienteData.departament_name || "",
          provincia: clienteData.provincia_name || "",
          distrito: clienteData.distrito_name || "",
          zone: clienteData.regiones_name || "",
          direccion: clienteData.direccion || "",
          direccionReferencia: clienteData.direccion_referencia || "",
          correoElectronico: clienteData.email || "",
          latitud: ventaData.latitud_cliente || null,
          longitud: ventaData.longitud_cliente || null,
          categoriaProducto: ventaDetallesData.categoria_id || "",
          ventaDetalleId: ventaDetallesData.id || "",
          producto: ventaDetallesData.id_producto || "",
          precio: ventaDetallesData.precio || "",
          telefonoMigrar: ventaDetallesData.telefono_migrar || "",
          fechaInstalacion: ventaDetallesData.fecha_programacion ? mostrarFechaLegible(ventaDetallesData.fecha_programacion) : "",
          fecha_venta: ventaData.fecha_venta || "",
          amPm: ventaDetallesData.AM_PM || "",
          dniFrontal: null,
          dniFrontalPreview: null,
          dniPosterior: null,
          dniPosteriorPreview: null,
          rostroClienteDni: null,
          rostroClienteDniPreview: null,
          frontisCasa: null,
          frontisCasaPreview: null,
          reciboLuz: null,
          reciboLuzPreview: null,
          otrosDocumentos: null,
          otrosDocumentosPreview: null,
        });

        const baseUrl = getBaseUrl(); 

        const previews = {};
        fotosRequisitos.forEach((foto) => {
          if (!foto.nombre_campo || !foto.nombre_archivo) return;

          const previewField = `${foto.nombre_campo}Preview`;
          const previewFieldNombre = `${foto.nombre_campo}NombreArchivo`;
          previews[previewField] = `${baseUrl}/uploads/${foto.nombre_archivo}`;
          previews[previewFieldNombre] = foto.nombre_archivo;
        });
        setForm((prev) => ({
          ...prev,
          ...previews,
        }));
        const fechaActual = new Date(ventaData.fecha_venta);
        const opcionesFecha = {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
        };
        setFechaFormateada(
          fechaActual.toLocaleDateString("es-ES", opcionesFecha)
        );
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error al obtener la venta:", error);
      }
    };

    if (id) {
      fetchCategorias();
      fetchRequisitos();
      cargarTipoDocumentos();
      fetchVenta();
    }
  }, [id, token]);

  const fetchCategorias = async () => {
    setLoadingCategorias(true);
    try {
      const data = await CategoriaService.getCategorias(token);
      setCategorias(data);
    } catch (err) {
      console.error("Error al cargar categorías:", err);
    } finally {
      setLoadingCategorias(false);
    }
  };

  const fetchRequisitos = async () => {
    try {
      const data = await RequisitoService.fetchRequisitos(token);
      setRequisitos(data);
    } catch (err) {
      console.error("Error al cargar requisitos:", err);
    }
  };

  const cargarTipoDocumentos = async () => {
    try {
      const tipos = await DocumentServices.getDocuments(token);
      setTiposDocumentos(tipos || []);
    } catch (error) {
      console.error("Error al cargar tipos de Documentos:", error);
    }
  };

  const fetchProductos = async (value) => {
    if (!value) return [];
    setLoadingProductos(true);
    try {
      const response = await ProductService.fetchProductosPorCategoria(token, value);
      setProductos(response.data);
      return response.data;
    } catch (err) {
      console.error("Error al cargar productos:", err);
      setError("Error al cargar los productos.");
    } finally {
      setLoadingProductos(false);
    }
  };


  const nextStep = () => {
    if (currentStep < 5) {
      setCurrentStep(currentStep + 1);
      setError("");
    }
  };

  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
      setError("");
    }
  };

  useEffect(() => {
    if (form.categoriaProducto) {
      const productosDeCategoria = productos.filter(
        (producto) => producto.categoria_id === form.categoriaProducto
      );
      setProductosFiltrados(productosDeCategoria);
    }
  }, [form.categoriaProducto, productos]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (currentStep < 5) {
      nextStep();
      return;
    }

    // Si estamos en el último paso, enviar todo
    setLoading(true);
  };

  const renderStep1 = () => (
    <div className="form-section">
      <h3 className="section-title">Datos del Cliente</h3>

      <div className="form-grid">
        <div className="">
          <label>Código de Cliente</label>
          <p className="info-text">{form.codigoCliente || "—"}</p>
        </div>
        <div className="">
          <label>Tipo de Documento *</label>
          <p className="info-text">
            {tiposDocumentos.find((t) => t.id == form.tipoDocumento)
              ?.description || "—"}
          </p>
        </div>
      </div>

      <div className="form-grid">
        <div className="">
          <label>Número de Documento *</label>
          <div className="input-with-button">
            <p className="info-text">{form.numeroDocumento || "—"}</p>
          </div>
          {errors.numeroDocumento && (
            <span className="error">{errors.numeroDocumento}</span>
          )}
        </div>
        <div className="">
          <label>Nombres *</label>
          <p className="info-text">{form.nombres || "—"}</p>
        </div>
      </div>

      <div className="form-grid">
        <div className="">
          <label>Apellido Paterno *</label>
          <p className="info-text">{form.apellidoPaterno || "—"}</p>
        </div>
        <div className="">
          <label>Apellido Materno</label>
          <p className="info-text">{form.apellidoMaterno || "—"}</p>
        </div>
      </div>

      <div className="form-grid">
        <div className="">
          <label>Teléfono de Contacto *</label>
          <p className="info-text">{form.telefonoContacto || "—"}</p>
        </div>
        <div className="">
          <label>Nombres Completos / Razón Social</label>
          <div className="input-with-button">
            <p className="info-text">{form.nombresCompletos || "—"}</p>
            {form.tipoDocumento === "4" && (
              <button
                type="button"
                className="contact-btn"
                title="Seleccionar contacto"
                onClick={abrirModalRepresentantes}
              >
                <User size={24} color="white" />
              </button>
            )}
          </div>
          {mostrarModalRepresentantes && (
            <ModalRepresentantesConsult
              clientesSeleccionados={representantes}
              onGuardar={actualizarRepresentantes}
              onCerrar={cerrarModalRepresentantes}
              numero={form.numeroDocumento}
              tipoDocumento={form.tipoDocumento}
              token={token}
            />
          )}
        </div>
      </div>
    </div>
  );

  const renderStep2 = () => {
    return (
      <div className="form-section">
        <h3 className="section-title"> Dirección del cliente</h3>

        <div className="form-grid">
          <div>
            <label>Departamento</label>
            <p className="info-text">{form.departamento || "—"}</p>
          </div>
          <div>
            <label>Provincia</label>
            <p className="info-text">{form.provincia || "—"}</p>
          </div>
        </div>

        <div className="form-grid">
          <div>
            <label>Distrito</label>
            <p className="info-text">{form.distrito || "—"}</p>
          </div>
          <div>
            <label>Zona</label>
            <p className="info-text">{form.zone || "—"}</p>
          </div>
        </div>

        <div className="form-grid">
          <div className="form-group">
            <label>Correo Electrónico</label>
            <p className="info-text">{form.correoElectronico || "—"}</p>
          </div>
          <div className="form-group">
            <label>Teléfono de Contacto (Opcional)</label>
            <p className="info-text">{form.telefonoContacto2 || "—"}</p>
          </div>
        </div>

        <div className="form-grid">
          <div className="form-group">
            <label>Dirección *</label>
            <p className="info-text">{form.direccion || "—"}</p>
          </div>
          <div className="form-group">
            <label>Dirección de Referencia</label>
            <p className="info-text">{form.direccionReferencia || "—"}</p>
          </div>
        </div>
      </div>
    );
  };

  const renderStep3 = () => {
    return (
      <div className="form-section">
        <h3 className="section-title">Ubicación en el mapa</h3>
        <p>Verifica la ubicación aproximada del cliente en el mapa:</p>
        <UbicacionVentaConsult form={form} setForm={setForm} />
      </div>
    );
  };

  const renderStep4 = () => (
    <div className="form-section">
      <h3 className="section-title">Datos del Producto</h3>

      <div className="form-grid">
        <div className="form-group">
          <label>Categoría Producto</label>
          <p className="info-text">
            {categorias.find((c) => c.id === form.categoriaProducto)?.nombre ||
              "—"}
          </p>
        </div>
        <div className="form-group">
          <label>Producto</label>
          <p className="info-text">
            {productosFiltrados.find((p) => p.id === form.producto)
              ? `${productosFiltrados.find((p) => p.id === form.producto).nombre
              } - S/ ${productosFiltrados.find((p) => p.id === form.producto).precio
              }`
              : "—"}
          </p>
        </div>
      </div>

      <div className="form-grid">
        <div className="form-group">
          <label>Precio</label>
          <p className="info-text">{form.precio || "—"}</p>
        </div>
        <div className="form-group">
          <label>Teléfono a Migrar</label>
          <p className="info-text">{form.telefonoMigrar || "—"}</p>
        </div>
      </div>

      <div className="form-grid">
        <div className="form-group">
          <label>Fecha de Instalación</label>
          <p className="info-text">{form.fechaInstalacion || "—"}</p>
        </div>
        {/*  <div className="form-group">
          <label>AM/PM</label>
          <p className="info-text">
            {opcionesAmPm.find((o) => o.value === form.amPm)?.label || "—"}
          </p>
        </div> */}
      </div>
    </div>
  );

  const renderStep5 = () => (
    <div className="form-section">
      <h3 className="section-title">📷 Documentos Requeridos</h3>

      <div className="document-grid">
        {requisitos.map((req) => {
          const fieldName = req.nombre_campo;
          const previewField = `${fieldName}Preview`;
          const previewFieldNombre = `${fieldName}NombreArchivo`;
          const isRequired = req.obligatorio === "1";

          const fileName = form?.[previewFieldNombre];
          const previewUrl = form?.[previewField];

          const isPdf =
            typeof fileName == "string" &&
            fileName.toLowerCase().endsWith(".pdf");

          return (
            <div key={req.id} className="document-card">
              <label>
                {req.descripcion} {isRequired && "*"}
              </label>

              {previewUrl ? (
                <div className="image-preview">
                  {isPdf ? (
                    <div className="pdf-preview">
                      <span role="img" aria-label="PDF">📄</span>
                      <a
                        href={previewUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Ver documento
                      </a>
                    </div>
                  ) : (
                    <img
                      src={previewUrl}
                      alt={req.descripcion}
                      className="preview-image"
                      onClick={() => setPreviewUrl({ url: previewUrl, isPdf: false })}
                    />
                  )}
                </div>
              ) : (
                <div className="document-icon">
                  {isPdf ? "📄" : "📷"} <span className="no-doc">No cargado</span>
                </div>
              )}
            </div>
          );
        })}
      </div>

      {previewUrl && (
        <div className="preview-modal" onClick={() => setPreviewUrl(null)}>
          <div className="preview-content" onClick={(e) => e.stopPropagation()}>
            {previewUrl.isPdf ? (
              <iframe
                src={previewUrl.url}
                title="Vista previa PDF"
                width="100%"
                height="600px"
              />
            ) : (
              <img src={previewUrl.url} alt="Vista previa" />
            )}
            <button onClick={() => setPreviewUrl(null)}>Cerrar</button>
          </div>
        </div>
      )}
    </div>
  );

  const renderCurrentStep = () => {
    switch (currentStep) {
      case 1:
        return renderStep1();
      case 2:
        return renderStep2();
      case 3:
        return renderStep3();
      case 4:
        return renderStep4();
      case 5:
        return renderStep5();
      default:
        return renderStep1();
    }
  };

  return (
    <div className="ventas-admin-content">
      {loading && <Preloader />}
      <div className="breadcrumb-container">
        <span className="breadcrumb-link" onClick={handleBackToList}>
          ← Listado de Ventas
        </span>
        <span className="breadcrumb-current"> / Consultar Venta</span>
      </div>
      <div className="dashboard-card nuevo-producto-card">
        <span className="nueva-venta-title"> Consultar Venta</span>
        <span className="nueva-venta-subtitle">
          {form.perfil_vendedor} - {form.nombre_vendedor + " " + form.apellido_vendedor}
        </span>
        <span className="nueva-venta-subtitle">
          {fechaFormateada}
        </span>

        <form
          className="nueva-venta-form"
          onSubmit={handleSubmit}
          autoComplete="off"
        >
          {renderCurrentStep()}

          {error && <div className="error-message">{error}</div>}
          {success && <div className="success-message">{success}</div>}

          {!readOnly && (
            <div className="form-actions">
              {currentStep > 1 && (
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={prevStep}
                  disabled={loading}
                >
                  Anterior
                </button>
              )}
              {currentStep != 5 && (
                <button
                  className="btn btn-primary"
                  type="submit"
                  disabled={loading}
                >
                  {loading
                    ? "Procesando..."
                    : currentStep === 5
                      ? "Actualizar Venta"
                      : "Siguiente"}
                </button>
              )}
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default ConsultarVenta;
